import type { JoinProInfoPageData } from '@presentation/pages';

export interface JoinProInfoPageControllerData
  extends Pick<JoinProInfoPageData, 'proType' | 'type'> {}

export interface JoinProInfoPageControllerProps extends JoinProInfoPageControllerData {}
